import { Chip } from 'design-system';
import { ISlackChannelProps } from './SlackChannel';

const SlackChannelCommunities = (props: ISlackChannelProps) => {
  const { communityOptions = [], channel } = props;
  const { communities = [] } = channel;

  const mappedCurrentChannelCommunities = communityOptions.filter(({ value }) => {
    return communities.includes(value);
  });

  return (
    <>
      <div className="item-option-container">
        <label>Communities: </label>
        <div className="communities-container">
          {mappedCurrentChannelCommunities.map(({ label, value }) => {
            return (
              <div key={label}>
                <Chip label={label} key={`${label}_${value}`} color={'primary'}></Chip>
              </div>
            );
          })}
        </div>
      </div>
      <style>{`
        .communities-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 400px;
          margin-left: 8px;
          gap: 4px;
        }

        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default SlackChannelCommunities;
